// US state income tax — Phase 1 representative rates (%) for self-employment estimates.
// type: 'none' (no income tax), 'flat', or 'progressive' (single representative rate).
// Rates are simplified planning estimates for a typical freelancer and are user-overridable.
// Review/update annually.
// Wave-2 update (2026-10-26): NC, IN, and OH corrected to verified 2026 figures (NC 3.99 flat, IN 2.95 flat, OH 3 business-income rate).

export const US_STATES = [
  { code: '', name: 'Select your state…', rate: null, type: 'none' },
  { code: 'AL', name: 'Alabama', rate: 4.5, type: 'progressive' },
  { code: 'AK', name: 'Alaska (no income tax)', rate: 0, type: 'none' },
  { code: 'AZ', name: 'Arizona', rate: 2.5, type: 'flat' },
  { code: 'AR', name: 'Arkansas', rate: 3.9, type: 'progressive' },
  { code: 'CA', name: 'California', rate: 6.0, type: 'progressive' },
  { code: 'CO', name: 'Colorado', rate: 4.4, type: 'flat' },
  { code: 'CT', name: 'Connecticut', rate: 5.0, type: 'progressive' },
  { code: 'DE', name: 'Delaware', rate: 5.0, type: 'progressive' },
  { code: 'DC', name: 'District of Columbia', rate: 6.5, type: 'progressive' },
  { code: 'FL', name: 'Florida (no income tax)', rate: 0, type: 'none' },
  { code: 'GA', name: 'Georgia', rate: 5.39, type: 'flat' },
  { code: 'HI', name: 'Hawaii', rate: 7.5, type: 'progressive' },
  { code: 'ID', name: 'Idaho', rate: 5.7, type: 'flat' },
  { code: 'IL', name: 'Illinois', rate: 4.95, type: 'flat' },
  { code: 'IN', name: 'Indiana', rate: 2.95, type: 'flat' },
  { code: 'IA', name: 'Iowa', rate: 3.8, type: 'flat' },
  { code: 'KS', name: 'Kansas', rate: 5.25, type: 'progressive' },
  { code: 'KY', name: 'Kentucky', rate: 4.0, type: 'flat' },
  { code: 'LA', name: 'Louisiana', rate: 3.0, type: 'flat' },
  { code: 'ME', name: 'Maine', rate: 6.75, type: 'progressive' },
  { code: 'MD', name: 'Maryland', rate: 5.5, type: 'progressive' },
  { code: 'MA', name: 'Massachusetts', rate: 5.0, type: 'flat' },
  { code: 'MI', name: 'Michigan', rate: 4.25, type: 'flat' },
  { code: 'MN', name: 'Minnesota', rate: 6.8, type: 'progressive' },
  { code: 'MS', name: 'Mississippi', rate: 4.4, type: 'flat' },
  { code: 'MO', name: 'Missouri', rate: 4.7, type: 'progressive' },
  { code: 'MT', name: 'Montana', rate: 5.9, type: 'progressive' },
  { code: 'NE', name: 'Nebraska', rate: 5.2, type: 'progressive' },
  { code: 'NV', name: 'Nevada (no income tax)', rate: 0, type: 'none' },
  { code: 'NH', name: 'New Hampshire (no wage tax)', rate: 0, type: 'none' },
  { code: 'NJ', name: 'New Jersey', rate: 5.0, type: 'progressive' },
  { code: 'NM', name: 'New Mexico', rate: 4.7, type: 'progressive' },
  { code: 'NY', name: 'New York', rate: 6.0, type: 'progressive' },
  { code: 'NC', name: 'North Carolina', rate: 3.99, type: 'flat' },
  { code: 'ND', name: 'North Dakota', rate: 1.95, type: 'progressive' },
  { code: 'OH', name: 'Ohio', rate: 3, type: 'progressive' },
  { code: 'OK', name: 'Oklahoma', rate: 4.75, type: 'progressive' },
  { code: 'OR', name: 'Oregon', rate: 8.75, type: 'progressive' },
  { code: 'PA', name: 'Pennsylvania', rate: 3.07, type: 'flat' },
  { code: 'RI', name: 'Rhode Island', rate: 4.75, type: 'progressive' },
  { code: 'SC', name: 'South Carolina', rate: 6.2, type: 'progressive' },
  { code: 'SD', name: 'South Dakota (no income tax)', rate: 0, type: 'none' },
  { code: 'TN', name: 'Tennessee (no income tax)', rate: 0, type: 'none' },
  { code: 'TX', name: 'Texas (no income tax)', rate: 0, type: 'none' },
  { code: 'UT', name: 'Utah', rate: 4.55, type: 'flat' },
  { code: 'VT', name: 'Vermont', rate: 6.6, type: 'progressive' },
  { code: 'VA', name: 'Virginia', rate: 5.75, type: 'progressive' },
  { code: 'WA', name: 'Washington (no income tax)', rate: 0, type: 'none' },
  { code: 'WV', name: 'West Virginia', rate: 5.12, type: 'progressive' },
  { code: 'WI', name: 'Wisconsin', rate: 5.3, type: 'progressive' },
  { code: 'WY', name: 'Wyoming (no income tax)', rate: 0, type: 'none' },
];

export const getStateRate = (code) => {
  const s = US_STATES.find((x) => x.code === code);
  return s && s.rate != null ? s.rate : null;
};
